import React, { Component, Fragment } from 'react';
import Relay from 'react-relay';
import { Link } from 'react-router';
import classNames from 'classnames';
import { FormattedMessage, injectIntl } from "react-intl"
import { default as headerMessages } from "../../messages/header"
import ScrapbookHeader from '../modules/ScrapbookHeader';
import { getStyles, getStyleTag } from '../../styles/dynamicStyles'
import { getAccountSettings } from "../../scripts/accountSettings";
import settingsMessages from "../../messages/settings";

class User extends Component {

  render() {
    const { viewer, intl, children } = this.props;

    const accountSettings = getAccountSettings(
      intl.formatMessage(settingsMessages.authenticAccountId)
    )

    const contributionsEnabled = accountSettings.settings.contributions_enabled

    return (
      <main tabIndex={0} role="main" id="main" className="p-scrapbook">

        <div className={classNames('p-scrapbook__head rich-page-header state-has-overlap', {'c-mviewer__layout--fluid':false})}
             style={getStyles('rich-page-header')}>
          <ScrapbookHeader viewer={viewer} />
        </div>

        <div className={classNames('row column c-tabs c-tabs--pagey')} style={getStyles('c-tabs--pagey')}>
          {getStyleTag(['c-tabs__nav', 'c-tabs--pagey__tab'])}
          <nav className="c-tabs__nav" >
            <Link
              to="/user/sets"
              className="c-tabs__tab"
              activeClassName="state-active"
              style={getStyles('c-tabs__tab')}
            >
              <FormattedMessage {...headerMessages.sets} />
            </Link>
            {contributionsEnabled && (
              <Link
                to="/user/contributions"
                className="c-tabs__tab"
                activeClassName="state-active"
                style={getStyles('c-tabs__tab')}
              >
                <FormattedMessage {...headerMessages.contributions} />
              </Link>
            )}
            <Link
              to="/user/profile"
              className="c-tabs__tab"
              activeClassName="state-active"
              style={getStyles('c-tabs__tab')}
             >
              <FormattedMessage {...headerMessages.profile} />
            </Link>
          </nav>

          <div className="c-tabs__content state-active" style={getStyles('c-tabs__content')}>
            {children}
          </div>

        </div>

      </main>
    );
  }
}

export default Relay.createContainer(injectIntl(User), {

  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        ${ScrapbookHeader.getFragment('viewer')}
      }
    `
  }

});



// WEBPACK FOOTER //
// ./webapp/components/pages/User.js